module.exports = __webpack_public_path__ + "img/icon-money-line.98d18809.svg";